/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import * as HierarchiesAPI from 'HierarchiesAPI';

export const GET_SERVICE_AVAILABILITY = 'GET_SERVICE_AVAILABILITY';
export const GET_SERVICE_AVAILABILITY_SUCCESS = 'GET_SERVICE_AVAILABILITY_SUCCESS';
export const GET_SERVICE_AVAILABILITY_FAILURE = 'GET_SERVICE_AVAILABILITY_FAILURE';

const getManageAvailability = () => ({
  type: GET_SERVICE_AVAILABILITY,
});
const getManageAvailabilitySuccess = payload => ({
  type: GET_SERVICE_AVAILABILITY_SUCCESS,
  payload,
});
const getManageAvailabilityFailure = error => ({
  type: GET_SERVICE_AVAILABILITY_FAILURE,
  error,
});

export const fetchManageAvailability = () => dispatch => {
  dispatch(getManageAvailability());
  return HierarchiesAPI.getManageAvailability()
    .then(payload => {
      dispatch(getManageAvailabilitySuccess(payload));
      return payload;
    })
    .catch(error => {
      dispatch(getManageAvailabilityFailure(error));
      return error;
    });
};
